import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../components/Icon";
import Breadcrumbs from "../../components/Breadcrumbs";
import { createMyTicket } from "../../api/myTicketService";
import { showApiError, showToast } from "../../utils/toast";

export default function NewTicketPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ subject: "", description: "" });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErrors({});
    setSaving(true);
    try {
      const res = await createMyTicket(form);
      showToast("success", "Ticket raised");
      const id = res.data?.id;
      navigate(id ? `/portal/tickets/${id}` : "/portal/tickets");
    } catch (err) {
      if (err?.data?.errors) setErrors(err.data.errors);
      showApiError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Breadcrumbs
        items={[
          { label: "Tickets", to: "/portal/tickets" },
          { label: "New ticket" },
        ]}
      />
      <div className="page-head">
        <div>
          <button className="btn btn-ghost btn-sm" onClick={() => navigate(-1)} style={{ marginLeft: -8, marginBottom: 8 }}>
            <Icon name="chevron-left" size={14} /> Back
          </button>
          <h1 className="page-title">New ticket</h1>
          <div className="page-sub">Tell us what you need help with</div>
        </div>
      </div>

      <form className="card" onSubmit={submit} style={{ maxWidth: 720 }}>
        <div className="card-body col gap-md">
          <Field label="Subject" error={errors.subject?.[0]}>
            <input
              className="input"
              value={form.subject}
              onChange={(e) => setForm({ ...form, subject: e.target.value })}
              placeholder="Short summary of the issue"
              autoFocus
            />
          </Field>
          <Field label="Description" error={errors.description?.[0]}>
            <textarea
              className="textarea"
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              placeholder="Provide context, dates, GSTIN, etc."
              style={{ minHeight: 160 }}
            />
          </Field>
        </div>
        <div style={{ padding: 14, borderTop: "1px solid var(--border)", display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            <Icon name="send" size={13} /> {saving ? "Submitting…" : "Submit ticket"}
          </button>
        </div>
      </form>
    </>
  );
}

function Field({ label, error, children }) {
  return (
    <div className="field">
      <label className="field-label">{label}</label>
      {children}
      {error && <div className="field-error">{error}</div>}
    </div>
  );
}
